import { PhoneModel } from "src/app/models/common/phone-model";
import { CompanyModel } from "src/app/models/customer_master_model/company-model";
import { UserStatus } from "../master-data/user-form-external/external-my-team.model";

export interface IUserAccessModel {
    email: string;
    username: string;
    first_name: string;
    last_name: string;
    id: string;
    role: string;
    user_status: UserStatus;
    company: CompanyModel;
    phone: PhoneModel;
}

export interface IMenuModel {
    id: string;
    updated_at: string;
    created_at: string;
    is_active: boolean;
    name: string;
    display_for_role: string;
    page_url: string;
    sequence: number;
    display_in_mobile_app: boolean;
    quick_link: boolean;
    quick_link_sequence: number;
    read_only: boolean;
    icon: string;
    show_in_menu: boolean;
    is_default_page_candidate: boolean;
    created_by?: any;
    updated_by?: any;
    module: string;
}

export interface IReportModel {
    id: string;
    is_implemented: boolean;
    updated_at: Date;
    created_at: Date;
    is_active: boolean;
    dev_name: string;
    description: string;
    report_frequency: string;
    procedure_name: string;
    procedure_type: string;
    last_initiated_at: Date;
    sequence: number;
    created_by: string;
    updated_by: string;
    display_in_menus: IMenuModel[];
    name: string;
    purpose: string;
    fields: string;
    user_access: IUserAccessModel[];
}

export interface IReportPostModel {
    id: string;
    name: string;
    purpose: string;
    fields: string;
    user_access: IUserAccessModel[];
}

export interface IReportError {
    id: string[];
    name: string[];
    purpose: string[];
    fields: string[];
    user_access: string[];
}

export class ReportModel implements IReportPostModel {
    id: string;
    name: string;
    purpose: string;
    fields: string;
    user_access: IUserAccessModel[];

    error: IReportError;

    constructor() {
        this.id = null;
        this.name = null;
        this.purpose = null;
        this.fields = null;
        this.user_access = [];

        this.resetReportErrors();
    }

    resetReportErrors() {
        this.error = {
            id: [],
            name: [],
            purpose: [],
            fields: [],
            user_access: [],
        }
    }

    getReportSavePayload() {
        return {
            name: this.name,
            purpose: this.purpose,
            fields: this.fields,
            user_access: this.user_access.map(item => item.id),
        }
    }
}